const rsDevMode = window.location.host.includes('localhost')
  || window.location.host.includes('staging')
  || window.location.host.startsWith('127.0');

const storeContextSessionId = () => {
  const defaultExp = new Date();
  defaultExp.setTime(defaultExp.getTime() + (30 * 60 * 1000)); // rs session expires after 30 min by default

  const { rudderanalytics } = window;
  if (!rudderanalytics.getSessionId) return;

  const currentSessionId = rudderanalytics.getSessionId();
  Cookies.set('rs_session_id', currentSessionId, { expires: defaultExp, secure: true });
}

const logProperiesSize = (properties) => {
  const jsonString = JSON.stringify(properties);
  const maxSize = 32000;

  // Assumes UTF-8 encoding
  const sizeInBytes = new TextEncoder().encode(jsonString).length;
  console.log("Size of `RS properties` in bytes:", sizeInBytes, ', max size:', maxSize);

  if (sizeInBytes > maxSize) {
    console.warn("Warning: JSON size exceeds Rudderstack's 32KB limit");
  }
}

const logEvent = (eventType, properties) => {
  if (rsDevMode) {
    console.warn(`Rudderstack not initialized – ${eventType}. Properties: ${JSON.stringify(properties)}`);
    logProperiesSize(properties);
  }
}

const trackSubmissionWithController = (selector) => {
  const submittedEventControllerName = 'rudderstack--checkout-step-submitted';
  document.querySelector(
    `${selector}[data-controller="${submittedEventControllerName}"]`
  )[submittedEventControllerName].track();
}

const renderRudderstackScript = () => {

  const script = document.createElement('script');
  script.type = 'text/javascript';
  script.innerHTML = buildRsScript();

  document.body.appendChild(script);
}

const buildRsScript = () => {
  const rudderstackJsWriteKey = window.rudderstackEnvVars.write_key;
  const rudderstackDataPlaneUrl = window.rudderstackEnvVars.data_plane_url;
  const rudderstackAnonymousId = window.rudderstackEnvVars.anonymous_id;
  const rudderstackJsUseBeacon = window.rudderstackEnvVars.js_use_beacon;

  return `!function(){"use strict";window.RudderSnippetVersion="3.2.0";var e="rudderanalytics";window[e]||(window[e]=[])
  ;var rudderanalytics=window[e];if(Array.isArray(rudderanalytics)){
  if(true===rudderanalytics.snippetExecuted&&window.console&&console.error){
  console.error("RudderStack JavaScript SDK snippet included more than once.")}else{rudderanalytics.snippetExecuted=true,
  window.rudderAnalyticsBuildType="legacy";var sdkBaseUrl="https://cdn.rudderlabs.com";var sdkVersion="v3"
  ;var sdkFileName="rsa.min.js";var scriptLoadingMode="async"
  ;var r=["setDefaultInstanceKey","load","ready","page","track","identify","alias","group","reset","setAnonymousId","startSession","endSession","consent","addCustomIntegration"]
  ;for(var n=0;n<r.length;n++){var t=r[n];rudderanalytics[t]=function(r){return function(){var n
  ;Array.isArray(window[e])?rudderanalytics.push([r].concat(Array.prototype.slice.call(arguments))):null===(n=window[e][r])||void 0===n||n.apply(window[e],arguments)
  }}(t)}try{
  new Function('class Test{field=()=>{};test({prop=[]}={}){return prop?(prop?.property??[...prop]):import("");}}'),
  window.rudderAnalyticsBuildType="modern"}catch(i){}var d=document.head||document.getElementsByTagName("head")[0]
  ;var o=document.body||document.getElementsByTagName("body")[0];window.rudderAnalyticsAddScript=function(e,r,n){
  var t=document.createElement("script");t.src=e,t.setAttribute("data-loader","RS_JS_SDK"),r&&n&&t.setAttribute(r,n),
  "async"===scriptLoadingMode?t.async=true:"defer"===scriptLoadingMode&&(t.defer=true),
  d?d.insertBefore(t,d.firstChild):o.insertBefore(t,o.firstChild)},window.rudderAnalyticsMount=function(){!function(){
  if("undefined"==typeof globalThis){var e;var r=function getGlobal(){
  return"undefined"!=typeof self?self:"undefined"!=typeof window?window:null}();r&&Object.defineProperty(r,"globalThis",{
  value:r,configurable:true})}
  }(),window.rudderAnalyticsAddScript("".concat(sdkBaseUrl,"/").concat(sdkVersion,"/").concat(window.rudderAnalyticsBuildType,"/").concat(sdkFileName),"data-rsa-write-key","${rudderstackJsWriteKey}")
  },
  "undefined"==typeof Promise||"undefined"==typeof globalThis?window.rudderAnalyticsAddScript("https://polyfill-fastly.io/v3/polyfill.min.js?version=3.111.0&features=Symbol%2CPromise&callback=rudderAnalyticsMount"):window.rudderAnalyticsMount()
  ;var loadOptions={
    sameDomainCookiesOnly: true, 
    useBeacon: ${rudderstackJsUseBeacon},
  };
  rudderanalytics.load("${rudderstackJsWriteKey}", "${rudderstackDataPlaneUrl}",loadOptions)}}}();
  rudderanalytics.setAnonymousId("${rudderstackAnonymousId}");`
}

export const trackEvent = (name, properties) => {
  try {
    const { rudderanalytics, rudderstackEnvVars: { global_properties } } = window;
    // correct singlequote render
    if (global_properties['store_name']) {
        global_properties['store_name'] = global_properties['store_name'].replace(/&#39;/g, "'")
    }
    const decoratedProperties = { ...global_properties, ...properties };

    if (rsDevMode) logEvent(name, decoratedProperties);
    if (rudderanalytics) rudderanalytics.track(name, decoratedProperties);
  } catch (error) {
    console.error('RS Error:', error);
  }
}

const RudderstackHelpers = {
  renderRudderstackScript,
  storeContextSessionId,
  trackEvent,
  trackSubmissionWithController,
}

export default RudderstackHelpers;
